// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendor":"da5fb4a4939f4127ae64","styles":"d02605243383e01c52b2"}[chunkId] + ".css";
};